module.exports = __webpack_public_path__ + "static/media/fvs_hamburgerKunsthalle_22.5998b50d.jpg";